import { apBasePath } from "./_base";

export default apBasePath.appendPathSegment<{}>("/guest-registration");